import { ReactElement } from 'react';
import classNames from 'classnames';
import { CARD_BOX_TITLE_SIZE, CardBox } from 'b2b-components/theme/components/CardBox';
import { Props } from './';
import './BoxPlaceholder.scss';

export const BoxPlaceholder = ({ title, children, className }: Props): ReactElement => (
  <CardBox
    title={title}
    titleSize={CARD_BOX_TITLE_SIZE.large}
    className={classNames(className, 'BoxPlaceholder')}
  >
    {children}
  </CardBox>
);
